<template>
    <div class="roleListPages">
        <Row>
            <Col span="6">
                <Col span="24" class="roleNameList">
                    <Col span="24" class="item th">
                        <Col span="4">序号</Col>
                        <Col span="15">角色名称</Col>
                        <Col span="5"><Icon type="ios-add-circle-outline" size="20" color="#000000" @click="addRole"/></Col>
                    </Col>
                    <Col span="24" class="roleNameListContent">
                        <Col span="24" class="item" v-for="(item,index) in roleList" :key="item.id">
                            <Col span="4">{{index+1}}</Col>
                            <Col span="15" class="roleName">
                                <div :class="item.checked === true ? 'active' : ''" @click="tagChange(item)">{{item.name}}</div>
                            </Col>
                            <Col span="5">
                                <Icon type="ios-create-outline" size="20" @click="editRole(item)"/>
                                <Icon type="ios-close-circle-outline" size="20" @click="removeRole(item.id)"/>
                            </Col>
                        </Col>
                    </Col>
                </Col>
            </Col>
            <Col span="18" class="permissionsList">
                <Col span="24">
                    <Tabs :value="tabActive" @on-click="tabClick">
                        <TabPane :v-if="permissionsData.length" v-for="(item,index) in permissionsData" :key="index" :label="item.label" :name="index+''" class="permissionsListPane">
                            <!-- 第一层 -->
                            <Col span="24">
                                <Checkbox v-model="item.checked" :disabled="checkboxDisabled" @on-change="oneCheckBoxItem(index)">
                                    <span style="font-weight:bold" >{{item.label}}</span>
                                </Checkbox>
                            </Col>
                            <Col span="24" :v-if="item.children.length" v-for="(two,i) in item.children" :key="two.value" class="permissionsItem">
                                <!-- 第二层 -->
                                <Col span="24" class="title">
                                  <Checkbox v-model="two.checked" :disabled="checkboxDisabled" @on-change="twoCheckBoxItem(index,i)">{{two.label}}</Checkbox>
                                </Col>
                                <Col span="24" style="padding-left:40px;margin:6px 0" v-if="two.children.length">
                                    <div v-for="(three,k) in two.children" :key="k">
                                        <!-- 第三层 -->
                                        <Checkbox style="display:block;margin-bottom:10px" :disabled="checkboxDisabled" v-model="three.checked" @on-change="threeCheckBoxItem(index,i,k)">{{three.label}}</Checkbox>
                                        <!-- 第四层 -->
                                        <div style="margin-bottom:10px;padding-left:40px" v-for="(four,j) in three.children" :key="j">
                                            <Checkbox style="display:block;margin-bottom:10px" :disabled="checkboxDisabled" v-model="four.checked" @on-change="fourCheckBoxItem(index,i,k,j)">{{four.label}}</Checkbox>
                                            <!-- 第五层 -->
                                            <div style="padding-left:40px;display:inline-block;margin-bottom:10px;" v-for="(five,p) in four.children" :key="p">
                                                <Checkbox :disabled="checkboxDisabled" v-model="five.checked" @on-change="fiveCheckBoxItem(index,i,k,j,p)">{{five.label}}</Checkbox>
                                            </div>
                                        </div>
                                    </div>     
                                </Col>
                            </Col>
                        </TabPane>
                    </Tabs>
                </Col>
                <Button type="primary" @click="editPermissions" class="opertion_btn">{{btnText}}</Button>
            </Col>
        </Row>
        <Modal
            v-model="roleNameShow"
            :title="roleNameTitle">
            <Form :model="formItem" :label-width="80">
                <FormItem label="角色名称">
                    <Input v-model="formItem.name" placeholder="请输入" :maxlength="20"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="close">取消</Button>
                <Button type="primary" size="large" @click="submitRole">确定</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
export default {
    name:'roleList',
    data(){
        return{
            btnText:"编辑",
            getRoleEditId:'',
            roleList:[],
            roleNameShow:false,
            roleNameTitle:'',
            formItem:{
                name:''
            },
            checkboxDisabled:true,
            tabActive:'0',
            permissionsData:[],
            roleDetailData:{}
        }
    },
    created(){
        
    },
    mounted(){
        this.apiPermissionAll()
        this.apiRoleList()
    },
    methods:{
        // 第一级菜单操作
        oneCheckBoxItem(index_one){
            if(this.permissionsData[index_one].checked){
                if(this.permissionsData[index_one].children.length){
                    this.menuSetChecked(index_one,true)
                }
            }else{
                this.menuSetChecked(index_one,false)
            }
        },
        // 第二级菜单操作
        twoCheckBoxItem(index_one,index_two){
            if(this.permissionsData[index_one].children[index_two].checked){
                this.permissionsData[index_one].checked = true
                if(this.permissionsData[index_one].children[index_two].children.length){
                    for(let three of this.permissionsData[index_one].children[index_two].children){
                        three.checked = true
                        if(three.children.length){
                            for(let four of three.children){
                                four.checked = true
                                if(four.children.length){
                                    for(let five of four.children){
                                        five.checked = true
                                    }
                                }
                            }
                        }
                    }
                }
            }else{
                let checkedNum = 0
                for(let item of this.permissionsData[index_one].children){
                    if(item.checked){
                        checkedNum++
                    }
                }
                if(checkedNum == 0){
                    this.permissionsData[index_one].checked = false
                }
                if(this.permissionsData[index_one].children[index_two].children.length){
                    for(let three of this.permissionsData[index_one].children[index_two].children){
                        three.checked = false
                        if(three.children.length){
                            for(let four of three.children){
                                four.checked = false
                                if(four.children.length){
                                    for(let five of four.children){
                                        five.checked = false
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        //第三级菜单操作
        threeCheckBoxItem(index_one,index_two,index_three){
            if(this.permissionsData[index_one].children[index_two].children[index_three].checked){
                this.permissionsData[index_one].checked = true
                this.permissionsData[index_one].children[index_two].checked = true
                if(this.permissionsData[index_one].children[index_two].children[index_three].children.length){
                    for(let four of this.permissionsData[index_one].children[index_two].children[index_three].children){
                        four.checked = true
                        if(four.children.length){
                            for(let five of four.children){
                                five.checked = true
                            }
                        }
                    }
                }
            }else{
                let checkedNum = 0
                for(let item of this.permissionsData[index_one].children[index_two].children){
                    if(item.checked){
                        checkedNum++
                    }
                }
                if(checkedNum == 0){
                    this.permissionsData[index_one].children[index_two].checked = false
                }
                let twoMenuCheckNum = 0
                for(let item of this.permissionsData[index_one].children){
                    if(item.checked){
                        twoMenuCheckNum++
                    }
                }
                if(twoMenuCheckNum == 0){
                    this.permissionsData[index_one].checked = false
                }
                if(this.permissionsData[index_one].children[index_two].children[index_three].children.length){
                    for(let four of this.permissionsData[index_one].children[index_two].children[index_three].children){
                        four.checked = false
                        if(four.children.length){
                            for(let five of four.children){
                                five.checked = false
                            }
                        }
                    }
                }
            }
            console.log("this.permissionsData",this.permissionsData)
        },
        //第四级菜单操作
        fourCheckBoxItem(index_one,index_two,index_three,index_four){
            if(this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].checked){
                this.permissionsData[index_one].checked = true
                this.permissionsData[index_one].children[index_two].checked = true
                this.permissionsData[index_one].children[index_two].children[index_three].checked = true
                for(let five of this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].children){
                    five.checked = true
                }
            }else{
                for(let five of this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].children){
                    five.checked = false
                }

                let fourMenuCheckNum = 0
                for(let four of this.permissionsData[index_one].children[index_two].children[index_three].children){
                    if(four.checked){
                        fourMenuCheckNum++
                    }
                }
                if(fourMenuCheckNum == 0){
                    this.permissionsData[index_one].children[index_two].children[index_three].checked = false
                }
                let threeCheckedNum = 0
                for(let item of this.permissionsData[index_one].children[index_two].children){
                    if(item.checked){
                        threeCheckedNum++
                    }
                }
                if(threeCheckedNum == 0){
                    this.permissionsData[index_one].children[index_two].checked = false
                }
                let twoMenuCheckNum = 0
                for(let item of this.permissionsData[index_one].children){
                    if(item.checked){
                        twoMenuCheckNum++
                    }
                }
                if(twoMenuCheckNum == 0){
                    this.permissionsData[index_one].checked = false
                }

            }
            console.log("this.permissionsData",this.permissionsData)
        },
        //第五级菜单操作
        fiveCheckBoxItem(index_one,index_two,index_three,index_four,index_five){
            if(this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].children[index_five].checked){
                this.permissionsData[index_one].checked = true
                this.permissionsData[index_one].children[index_two].checked = true
                this.permissionsData[index_one].children[index_two].children[index_three].checked = true
                this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].checked = true
            }else{
                let fiveMenuCheckNum = 0
                for(let five of this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].children){
                    if(five.checked){
                        fiveMenuCheckNum++
                    }
                }
                if(fiveMenuCheckNum == 0){
                    this.permissionsData[index_one].children[index_two].children[index_three].children[index_four].checked = false
                }



                let fourMenuCheckNum = 0
                for(let four of this.permissionsData[index_one].children[index_two].children[index_three].children){
                    if(four.checked){
                        fourMenuCheckNum++
                    }
                }
                if(fourMenuCheckNum == 0){
                    this.permissionsData[index_one].children[index_two].children[index_three].checked = false
                }
                let threeCheckedNum = 0
                for(let item of this.permissionsData[index_one].children[index_two].children){
                    if(item.checked){
                        threeCheckedNum++
                    }
                }
                if(threeCheckedNum == 0){
                    this.permissionsData[index_one].children[index_two].checked = false
                }
                let twoMenuCheckNum = 0
                for(let item of this.permissionsData[index_one].children){
                    if(item.checked){
                        twoMenuCheckNum++
                    }
                }
                if(twoMenuCheckNum == 0){
                    this.permissionsData[index_one].checked = false
                }

            }
            console.log("this.permissionsData",this.permissionsData)
        },
        menuSetChecked(index,checked){
            for(let one of this.permissionsData[index].children){
                one.checked = checked
                if(one.children.length){
                    for(let two of one.children){
                        two.checked = checked
                        if(two.children.length){
                            for(let three of two.children){
                                three.checked = checked
                                if(three.children.length){
                                    for(let four of three.children){
                                        four.checked = checked
                                        if(four.children.length){
                                            for(let five of four.children){
                                                five.checked = checked
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        ,
        tabClick(name){
            this.tabActive = name
        },
        apiPermissionAll(){
            serve.fetchGet(api.permissionAll,{}).then(data => {
                console.log(data)
                this.permissionsData = this.permissionTree(data.dictionaries) 
                console.log("permissionsData",this.permissionsData) 
            }).catch((error)=>{
                // this.$Message.error(error.response.data.message);
            })
        },
        permissionTree(data,pid=0){
            // console.log('permissionTree',data) 
            let arr = []

            for(let item of data){
                if(item.child_permissions && item.child_permissions.length){
                    let child = this.permissionTree(item.child_permissions,item.id);
                    arr.push({
                        value: item.id,
                        label: item.show_name,
                        children: child,
                        checked:false
                });
                }else{
                    arr.push({
                        value: item.id,
                        label: item.show_name,
                        children: [],
                        checked:false
                    })
                }
            }
            
            // console.log("__", arr)
            return arr
        },
        apiRoleList(){
            serve.fetchGet(api.roleAll,{}).then(data => {
                console.log(data)
                let index = 0
                for(let item of data.data){
                    if(index === 0){
                        item.checked = true
                        this.apiRoleDetail(item.id)
                    }else{
                        item.checked = false
                    }
                    index++
                }
                this.roleList = data.data
                
            })
        },
        apiRoleAdd(){
            serve.fetchPost(api.role,this.formItem).then(data => {
                console.log(data)
                this.$Message.success('添加成功')
                this.roleNameShow = false
                this.apiRoleList()
                
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiRoleEdit(){
            serve.fetchPut(api.role+'/'+this.getRoleEditId,this.formItem).then(data => {
                console.log(data)
                this.$Message.success('编辑成功')
                this.roleNameShow = false
                this.apiRoleList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiRoleRemove(id){
            serve.fetchDelete(api.role+'/'+id,{}).then(data => {
                console.log(data)
                this.$Message.success('删除成功')
                this.roleNameShow = false
                this.apiRoleList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        apiRoleDetail(id){
            serve.fetchGet(api.role+'/'+id,{}).then(data => {
                console.log(data)
                this.roleDetailData = data.data
                let own_permission = data.data.own_permission
                this.setPermission(own_permission)
            })
        },
        apiRoleSave(){
            let permission_id = []
            console.log(this.permissionsData)
            for(let item of this.permissionsData){
                if(item.checked){
                    permission_id.push(item.value)
                }
                for(let two of item.children){
                    if(two.checked){
                        permission_id.push(two.value)
                    }
                    for(let three of two.children){
                        if(three.checked){
                            permission_id.push(three.value)
                        }
                        for(let four of three.children){
                            if(four.checked){
                                permission_id.push(four.value)
                            }
                            for(let five of four.children){
                                if(five.checked){
                                    permission_id.push(five.value)
                                }
                            }  
                        }       
                    }
                }
            }
            console.log('ID',permission_id)
            let params = {
                name:this.roleDetailData.name,
                permission_id:permission_id
            }
            serve.fetchPut(api.role+'/'+this.roleDetailData.id,params).then(data => {
                console.log(data)
                this.$Message.success('保存成功')
                this.checkboxDisabled = true
                this.btnText = '编辑'
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },
        setPermission(own_permission){
            console.log("own_permission",own_permission)
            for(let item of this.permissionsData){
                if(own_permission.indexOf(item.value) != -1){
                    item.checked = true
                }
                for(let two of item.children){
                    if(own_permission.indexOf(two.value) != -1){
                        two.checked = true
                    }
                    for(let three of two.children){
                        if(own_permission.indexOf(three.value) != -1){
                            three.checked = true
                        }
                        for(let four of three.children){
                            if(own_permission.indexOf(four.value) != -1){
                                four.checked = true
                            }
                            for(let five of four.children){
                                if(own_permission.indexOf(five.value) != -1){
                                    five.checked = true
                                }  
                            }
                        }
                    }
                }
            }
            
        },
        addRole(){
            this.formItem.name = ''
            this.roleNameTitle = '添加角色'
            this.roleNameShow = true
        },
        editRole(item){
            this.getRoleEditId = item.id
            this.formItem.name = item.name
            this.roleNameTitle = '编辑角色'
            this.roleNameShow = true
        },
        removeRole(id){
            this.apiRoleRemove(id)
        },
        submitRole(){
            if(this.formItem.name === ''){
                this.$Message.warning('请输入')
                return
            }
            if(this.roleNameTitle === '添加角色'){
                this.apiRoleAdd()
                return
            }
            if(this.roleNameTitle === '编辑角色'){
                this.apiRoleEdit()
                return
            }
        },
        close(){
            this.roleNameShow = false
        },

        editPermissions(){
            if(this.checkboxDisabled){
                this.checkboxDisabled = false
                this.btnText = '保存'
            }else{
                this.apiRoleSave()
                
            }
        },
        //角色切换
        tagChange(item){
            this.tabActive='0'
            this.btnText = '编辑'
            if(this.roleList.length){
                for(let v of this.roleList){
                    v.checked = false
                }
            }
            item.checked = true
            this.checkboxDisabled = true
            //清空权限
            for(let item of this.permissionsData){
                item.checked = false
                for(let two of item.children){
                    two.checked = false
                    for(let three of two.children){
                        three.checked = false
                        for(let four of three.children){
                            four.checked = false
                            for(let five of four.children){
                                five.checked = false
                            }
                        }
                    }
                }
            }
            this.apiRoleDetail(item.id)
        }
    }
}
</script>
<style scope>
    .roleListPages{
        height: calc(100vh - 165px);
    }
    .roleNameList{
        border-right:1px solid #eee;
        text-align: center;
        padding-right:20px
    }
    .roleNameListContent{
        height: calc(100vh - 205px);
        overflow: auto
    }
    .permissionsListPane{
        height: calc(100vh - 220px);
        overflow: auto;
        padding:0 20px
    }
    .roleNameList .item{
        height: 40px;
        line-height: 40px
    }
    .roleNameList .th{
        font-weight: bold
    }
    .permissionsList{
        position: relative;
        padding-left: 20px
    }
    .permissionsItem{
        padding-bottom: 20px
    }
    .permissionsItem .title{
        padding-left:20px;
        line-height: 40px;
        font-weight: bold
    }
    .roleName{
        height:40px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis
    }
    .roleName div{
        height: 30px;
        line-height: 30px;
        border-radius:15px;
        background: #f7f7f7;
        margin: 5px 0;
        cursor: pointer;
    }
    .roleName div.active{
        background: #2d8cf0;
        color: #fff;
    }
    .opertion_btn{
        position: absolute;
        right: 0;
        top: 0
    }
</style>


// WEBPACK FOOTER //
// src/pages/SystemSetting/System/roleList.vue